import React, { useEffect, useState, useContext  } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import industry3 from '../img/merdekaeditdua.gif';
import { instance, instance2 } from '../utils/axiosInstance'; // Import axios instance
import translations from '../login/translations'; // Adjust the path as needed
import { LanguageContext } from '../login/LanguageContext';

export default function Signup() {
    const navigate = useNavigate();

    const { language, toggleLanguage } = useContext(LanguageContext); // Access language and toggle function

    const [emailAvailable, setEmailAvailable] = useState(null); // State to track email availability
    const [loading, setLoading] = useState(false); 

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            passwordConf: '',
            name: '',
            phone: ''
        },
        validationSchema: yup.object({
            email: yup
                .string()
                .email(translations[language].emailInvalid)
                .required(translations[language].emailEmpty)
                .test('email-validity', translations[language].emailInvalid, (value) => {
                    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
                    return emailRegex.test(value || '')
                }),
            password: yup.string().required(translations[language].passwordEmpty),
            passwordConf: yup
                .string()
                .oneOf([yup.ref('password'), null], translations[language].passwordAndPasswordConf) // Ensures password and confirmation match
                .required(translations[language].paswordConfReq),
            name: yup.string().required(translations[language].realNameReq), // Real name should not be empty
            phone: yup
                .string()
                .matches(/^[0-9]+$/, 'Phone number should only contain numbers') // Validate that phone number only contains numbers
                .required(translations[language].phoneReq) // Phone number should not be empty
        }),
        onSubmit: async (result) => {
            try {
                const response = await instance2.post('signup', result);
                const sendmail = await instance2.post('send-email', result);
                console.log(response);
                navigate('/sendmail', { state: { email: result.email } });
            } catch (error) {
                formik.setErrors({
                    email: translations[language].wrongEmail,
                    password: translations[language].wrongPassword
                });
            }
        }
    });

    // Function to check email availability by posting to the backend
    const checkEmailAvailability = async (email) => {
        setLoading(true); // Start the loading indicator
        try {
            // Send a POST request to the backend to check if the email is available
        console.log('emailavailabilityresponseinstance2', instance2)
            const response = await instance2.post('checkemail', { email });
            console.log('emailavailabilityresponse', response)
            console.log('emailavailabilityresponsestatus', response.status)

            // Based on the response status, update email availability
            if (response.status === 0) {
                setEmailAvailable(true); // Email is available
            } else {
                setEmailAvailable(false); // Email is not available
            }
        } catch (error) {
            console.error('Error checking email availability:', error);
            setEmailAvailable(false); // Assume email is unavailable in case of error
        } finally {
            setLoading(false); // Stop the loading indicator
        }
    };

    // Function to validate email and check its availability
    const handleEmailBlur = async (e) => {
        formik.handleBlur(e); // Mark the field as touched

        const email = e.target.value;

        // Check if the email passes validation
        if (!formik.errors.email && email) {
            // If the email is valid, check its availability
            await checkEmailAvailability(email);
        } else {
            setEmailAvailable(null); // Reset the email availability state if invalid
        }
    };

    // Function to capitalize the first letter of each word in the real name
    const capitalizeWords = (value) => {
        return value
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    };

    // Check if the submit button should be enabled or disabled
    const isSubmitDisabled =
        !emailAvailable || // Email must be available (true)
        formik.values.password !== formik.values.passwordConf || // Password and confirmation must match
        !formik.values.name || // Real name should not be empty
        !formik.values.phone || // Phone number should not be empty
        formik.errors.password || // Password validation errors
        formik.errors.passwordConf || // Password confirmation validation errors
        formik.errors.name || // Name validation errors
        formik.errors.phone; // Phone validation errors

    return (
        <div className="relative w-full">
            <div className="flex justify-center items-center h-full">
                <form
                    className=" w-full mx-auto mt-4"
                    onSubmit={formik.handleSubmit}
                    noValidate
                >
                    <div className='flex flex-row px-20 gap-10'>
                    {/* Email Input */}
                    <div className="flex flex-col mb-4 flex-1">
                        <label>Nama lengkap</label>
                        <input
                            className={`brelative bg-white p-2 rounded-[20px] border-none
                                ${formik.touched.email && formik.errors.email ? 'border-red-500' : ''}
                                ${emailAvailable === true ? 'border-blue-500' : ''}
                                ${emailAvailable === false ? 'border-red-500' : ''}
                            `}
                            type="text"
                            placeholder='Tuliskan nama lengkap anda'
                            name="email"
                            onChange={(e) => {
                                formik.handleChange(e);
                                setEmailAvailable(null); // Reset availability state when typing
                            }}
                            onBlur={handleEmailBlur} // Validate and check email availability on blur
                            value={formik.values.email}
                        />
                        <small className="text-red-500">
                            {formik.touched.email && formik.errors.email && formik.errors.email}
                        </small>
                        {/* Show loading indicator or availability message */}
                        {loading ? (
                            <div className="">
                                {/* Circular Progress Loader (You can style it or use a library like Material UI, Tailwind or any spinner component) */}
                                <small className="loader">{`${translations[language].wrongPassword}...`}</small> 
                            </div>
                        ) : (
                            <>
                                {emailAvailable === false && (
                                    <small className="text-red-500">{translations[language].emailNotAvail}</small>
                                )}
                                {emailAvailable === true && (
                                    <small className="text-blue-500">{translations[language].emailAvail}</small>
                                )}
                            </>
                        )}
                    </div>

{/* Phone Number Input */}
<div className="flex flex-col mb-4 flex-1">
    <label>{translations[language].phoneNum}</label>
    <input
        className={`relative bg-white p-2 rounded-[20px] border-none ${
            formik.touched.phone && formik.errors.phone ? 'border-red-500' : ''
        }`}
        type="text"
                            placeholder='Tuliskan nomor handphone anda'
        name="phone"
        onChange={(e) => {
            const value = e.target.value;
            if (/^[0-9]*$/.test(value)) { // Restrict input to numbers
                formik.setFieldValue('phone', value);
            }
        }}
        onBlur={formik.handleBlur}
        value={formik.values.phone}
    />
    <small className="text-red-500">
        {formik.touched.phone && formik.errors.phone && formik.errors.phone}
    </small>
</div>
</div>

<div className='flex flex-row px-20 gap-10'>
                    {/* Password Input */}
                    <div className="flex flex-col mb-4 flex-1">
                        <label>{translations[language].passwordLabel}</label>
                        <input
                            className={`relative bg-white p-2 rounded-[20px] border-none ${
                                formik.touched.password && formik.errors.password ? 'border-red-500' : ''
                            }`}
                            type="password"
                            placeholder='Kata sandi'
                            name="password"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.password}
                        />
                        <small className="text-red-500">
                            {formik.touched.password && formik.errors.password && formik.errors.password}
                        </small>
                    </div>

                    {/* Password Confirmation Input */}
                    <div className="flex flex-col mb-4 flex-1">
                        <label>{translations[language].passwordConfLabel}</label>
                        <input
                            className={`relative bg-white p-2 rounded-[20px] border-none ${
                                formik.touched.passwordConf && formik.errors.passwordConf ? 'border-red-500' : ''
                            }`}
                            type="password"
                            placeholder='Konfirmasi kata sandi'
                            name="passwordConf"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.passwordConf}
                        />
                        {formik.touched.passwordConf && formik.errors.passwordConf && (
                            <small className="text-red-500">{formik.errors.passwordConf}</small>
                        )}
                    </div>
                    </div>

                    <div className='flex flex-row px-20 gap-10 items-center justify-center flex-1'>
                    {/* Real Name Input */}
                    <div className="flex flex-col mb-4 flex-1">
                        <label>Daftarkan Anda sebagai admin dari:</label>
                        <input
                            className={`relative bg-white p-2 rounded-[20px] border-none ${
                                formik.touched.name && formik.errors.name ? 'border-red-500' : ''
                            }`}
                            type="text"
                            placeholder=''
                            name="name"
                            onChange={(e) => {
                                const value = capitalizeWords(e.target.value);
                                formik.setFieldValue('name', value); // Capitalize first letter of each word
                            }}
                            onBlur={formik.handleBlur}
                            value={formik.values.name}
                        />
                        <small className="text-red-500">
                            {formik.touched.name && formik.errors.name && formik.errors.name}
                        </small>
                    </div>
                    
    <label className="inline-flex items-center flex-1 gap-2">
      <input
        type="checkbox"
        defaultUnchecked
        className="h-8 w-8 appearance-none rounded-full border border-gray-900/20 bg-gray-900/10 checked:bg-blue-500 transition-all hover:scale-105 cursor-pointer focus:ring-0"
      />
      <div className="text-black text-xs text-left font-thin">
        Saya menyetujui{' '}
        <span
          className="text-red-500 cursor-pointer"
          onClick={"/"} // Toggles the state
        >
          Syarat & Ketentuan Dapur Merdeka
        </span>
      </div>
    </label>
    </div>

    <div className='flex flex-row px-20 gap-10'>
                    {/* Submit Button */}
                    <button
                        className={`w-full py-3 mt-8 ${
                            isSubmitDisabled ? 'bg-gray-300 cursor-not-allowed' : 'bg-merah-no hover:bg-merah-hover'
                        } text-white border rounded-[20px]`}
                        type="submit"
                        disabled={isSubmitDisabled} // Disable button if conditions are not met
                    >
                        {translations[language].submitLabel}
                    </button>
                    </div>

                    {/* <p className="text-center mt-8">{translations[language].loginPrompt}</p>

                    <Link to="/login">
                        <button
                            className="w-full py-3 mt-1 bg-merah-no hover:bg-merah-hover relative text-white border rounded-[20px]"
                            type="button"
                        >
                            {translations[language].loginButton}
                        </button>
                    </Link> */}
                </form>
            </div>
        </div>
    );
}
